import axiosInstance from "./axiosInstance";
import { parseJwt } from "../utils/authUtils";
import useAuthStore from "../../stores/authStore";

const LOGIN_URL = "/auth/login";
const REGISTER_URL = "/auth/register";
const ACTIVATE_URL = "/auth/activate-account";
const TOKEN_VALID_URL = "/auth/token-valid";
const VERIFY_MFA_URL = "/auth/verify";
const REQUEST_RESET_URL = "/auth/request-password-reset";
const RESET_PASSWORD_URL = "/auth/reset-password";
const RESEND_OTP_URL = "/auth/resend-otp";
const REQUEST_REACTIVATION_URL = "/auth/request-activate-account";

const authService = {
  login: async (email, password) => {
    return await axiosInstance.post(LOGIN_URL, { email, password });
  },

  // REGISTER
  register: async (userData) => {
    const response = await axiosInstance.post(REGISTER_URL, userData);
    return response.data; // Returns something like "Activation email sent"
  },

  activateAccount: async (token, newPassword) => {
    return await axiosInstance.post(
      `${ACTIVATE_URL}?token=${encodeURIComponent(token)}`,
      { password: newPassword },
    );
  },

  checkActivationTokenValid: async (token) => {
    return await axiosInstance.get(
      `${TOKEN_VALID_URL}?token=${encodeURIComponent(token)}`,
    );
  },

  verifyMfaCode: async (code) => {
    const response = await axiosInstance.post(
      `${VERIFY_MFA_URL}?token=${encodeURIComponent(code)}`,
    );
    const { accessToken, refreshToken, remarks } = response.data;
    if (accessToken && refreshToken) {
      useAuthStore.getState().setTokens(accessToken, refreshToken);
      const user = parseJwt(accessToken);
      return { success: true, user, remarks, accessToken, refreshToken };
    } else {
      throw new Error(remarks || "MFA verification failed.");
    }
  },

  resendMfaCode: async (email) => {
    return await axiosInstance.post(
      `${RESEND_OTP_URL}?email=${encodeURIComponent(email)}`,
    );
  },

  requestPasswordReset: async (email) => {
    return await axiosInstance.post(
      REQUEST_RESET_URL,
      {},
      { params: { email } },
    );
  },

  resetPassword: async (token, newPassword) => {
    return await axiosInstance.post(
      `${RESET_PASSWORD_URL}?token=${encodeURIComponent(token)}`,
      { password: newPassword },
    );
  },

  requestReactivation: async (email) => {
    return await axiosInstance.post(REQUEST_REACTIVATION_URL, { email });
  },

  // LOGOUT
  logout: () => {
    useAuthStore.getState().clearAuth();
    // Optionally notify backend to invalidate session
  },

  // CHECK AUTH STATUS
  isAuthenticated: () => {
    return useAuthStore.getState().isAuthenticated;
  },
};

export default authService;
